module.exports = __webpack_public_path__ + "img/UnlockIcon.9fcbbbde.svg";